<template>
  <login-callback-component />
</template>
    
<script>
import LoginCallbackComponent from "../components/login-by-google/Index.vue";
export default {
  name: "Login",
  components: {
    LoginCallbackComponent,
  },
  data: () => ({}),
};
</script>
    
<style>
</style>